
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Notification extends Vue {
	@Prop(String) readonly status!: any;
	@Prop(String) readonly title!: any;
	@Prop(String) readonly message!: any;

	// created(): void {
	//   this.$root.$emit('notify', [this.message, this.title]);
	// }
}
